import CategoriesSection from './categoriesSection/categoriesSection.component';

export { CategoriesSection };
